import { h } from 'preact'

const CircleCheckMark = () => {
    return (
        <svg className='correct-answer' fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="9" stroke="#1D1D1D" stroke-width="2"/>
            <path d="M15 8c-2.667 3.056-4 7-4 7l-2-3" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default CircleCheckMark